import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useAppEvent from 'hooks/useAppEvent';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { AppEventType } from 'models/Events';
import { LeadAvailablePipelineAction } from 'models/Leads';
import { TemplateModalParams, TemplateName } from './TemplateModal.types';

const useTemplateModalParamsProvider = () => {
  const { t } = useTranslation();
  const { publish } = useAppEvent();
  const { closeModal } = useAppModal();
  const { notifySuccess } = useNotify();

  return useCallback(
    ({
      leadUid,
      templateModalId,
      templateName,
    }: {
      leadUid: string;
      templateModalId: string;
      templateName: TemplateName;
    }): TemplateModalParams => {
      if (templateName === TemplateName.QUOTE) {
        return {
          leadUid,
          templateName,
          leadPipelineTemplateAction: LeadAvailablePipelineAction.SEND_QUOTE,
          updateLeadCallback: () => {
            closeModal(templateModalId);
            publish(AppEventType.LEAD_UPDATED, { lead: { uid: leadUid } });
          },
        };
      }

      if (templateName === TemplateName.HOLD_CONFIRMATION) {
        return {
          leadUid,
          templateName,
          leadPipelineTemplateAction: LeadAvailablePipelineAction.PLACE_ON_HOLD,
          updateLeadCallback: () => {
            closeModal(templateModalId);
            publish(AppEventType.LEAD_UPDATED, { lead: { uid: leadUid } });
            notifySuccess(t('componentTemplate.messageHasBeenSent'));
          },
        };
      }

      return { leadUid, templateName };
    },
    [closeModal, publish],
  );
};

export default useTemplateModalParamsProvider;
